export class AttachedTraitInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get trait() {
        return this.at.trait;
    }
    get isAttachedContent() {
        return this.at.reg.unifier === 'content';
    }
    get isTraitImported() {
        return this.at.aspect !== this.at.trait.aspect;
    }
}
